import { KETE, METHODOLOGY, VALUES } from "@/lib/content";

const Vision = () => <p className="text-lg leading-relaxed">AHU brings the Te Ahu vision to each person: the clarity, confidence and agency to flourish on their own terms.</p>;

const Values = () => (
  <>
    <div className="grid gap-5 sm:grid-cols-2">
      {VALUES.map((v) => (
        <div key={v.name}>
          <p className="font-display text-lg text-charcoal">{v.name}</p>
          <p className="text-sm text-gold-text mb-1">{v.meaning}</p>
          <p className="text-[15px] text-ink leading-relaxed">{v.line}</p>
        </div>
      ))}
    </div>
    <div className="mt-6 rounded-xl bg-charcoal p-5 text-alabaster">
      <p className="font-display text-lg">How these values work together</p>
      <p className="mt-2 text-alabaster/90 leading-relaxed">AHU offers you the space to find your own North Star. The journey towards it is yours to take.</p>
    </div>
  </>
);

const Methodology = () => (
  <ol className="space-y-5">
    {METHODOLOGY.map((m, i) => (
      <li key={m.name} className="flex gap-4">
        <span className="font-display text-gold-text text-lg w-5 shrink-0">{i + 1}</span>
        <div>
          <p className="font-medium text-charcoal">{m.name}</p>
          <p className="text-[15px] leading-relaxed">{m.text}</p>
          <p className="text-sm text-ink-soft mt-1">In your plan: {m.where}</p>
        </div>
      </li>
    ))}
  </ol>
);

const Kete = () => (
  <>
    <p className="leading-relaxed">Tāne climbed to the uppermost heavens and returned with three kete, baskets of knowledge, for the people. Each kete held a different kind of knowing, and together they offered what people need to live well.</p>
    <div className="mt-5 grid gap-3 sm:grid-cols-3">
      {KETE.map((k) => (
        <div key={k.key} className="rounded-xl bg-alabaster p-4">
          <p className="font-display text-charcoal">{k.name}</p>
          <p className="text-sm text-ink-soft mt-1">{k.desc}</p>
        </div>
      ))}
    </div>
    <p className="mt-4 text-sm text-ink-soft">Inspired by Te Ao Māori and Ngā Kete o te Wānanga.</p>
  </>
);

const Waharoa = () => (
  <>
    <p className="font-display text-lg text-charcoal">Step through the waharoa, and put the load down.</p>
    <p className="mt-2 leading-relaxed">AHU is a digital waharoa: a calm, private space to pause, put the load down and think clearly before your next step.</p>
    <ul className="mt-4 space-y-2 text-[15px]">
      <li><span className="font-medium text-charcoal">Restore worth:</span> reconnect with your own value.</li>
      <li><span className="font-medium text-charcoal">Reclaim mana:</span> choose your own path rather than reacting.</li>
      <li><span className="font-medium text-charcoal">Find steadiness:</span> put down some of the load you've been carrying.</li>
    </ul>
  </>
);

export const COACH = {
  vision: { summary: "Clarity, confidence and agency", Body: Vision },
  values: { summary: "Pono · Manaakitanga · Rangatiratanga · Whakapapa", Body: Values },
  methodology: { summary: "Six ways AHU works with you", Body: Methodology },
  kete: { summary: "The three baskets of knowledge", Body: Kete },
  waharoa: { summary: "A calm space to put the load down", Body: Waharoa },
};
